// PR log galat (INSTRUKSI 04/11/2026): galat di browser pembeli dikirim ke server (POST /api/galat-browser), sekali per sidik per pemuatan halaman.
// Server menyensor dan memeriksa ulang semua isian (server/sensor-galat.js). Tanpa layanan pihak ketiga, tanpa token, tanpa cookie. Pelapor ini tidak
// pernah melempar dan tidak pernah melaporkan kegagalannya sendiri.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const ALAMAT = `${BACKEND_URL}/api/galat-browser`;
const COMMIT = String(process.env.REACT_APP_COMMIT || "").slice(0, 7);

const MAKS_PESAN = 800;          // server memotong lagi ke 300 sesudah menyensor
const MAKS_TUMPUKAN = 5;
const MAKS_LAPORAN_PER_MUAT = 10;
const JEDA_HITUNGAN_MS = 5000;

const ABAIKAN = /ResizeObserver loop|^Script error\.?$|^cancell?ed$|aborted a request|navigation (?:was )?(?:cancel|abort)/i;
const JARINGAN = /failed to fetch|networkerror|load failed|network request failed|network error|internet connection appears to be offline|err_network|err_internet_disconnected/i;
const MUAT_BERKAS = /loading (?:css )?chunk|chunkloaderror|dynamically imported module/i;
const SKEMA_EKSTENSI = /(?:chrome|moz|safari|safari-web|ms-browser)-extension:/i;

// Halaman yang memuat nilai di alamatnya → pola; selain itu segmen huruf kecil tetap, sisanya ":x"
const POLA_HALAMAN = [[/^\/produk\/[^/]+/, "/produk/:id"], [/^\/katalog\/[^/]+/, "/katalog/:kategoriSlug"], [/^\/panduan\/[^/]+/, "/panduan/:slug"],
  [/^\/invoice\/[^/]+/, "/invoice/:token"], [/^\/atur-sandi\/[^/]+/, "/atur-sandi/:token"], [/^\/pesanan\/[^/]+\/lacak/, "/pesanan/:id/lacak"],
  [/^\/pesanan\/[^/]+/, "/pesanan/:id"], [/^\/admin\/pesanan\/[^/]+/, "/admin/pesanan/:id"]];

export function polaHalaman(pathname) {
  const p = String(pathname || "/");
  for (const [re, pola] of POLA_HALAMAN) if (re.test(p)) return pola;
  return "/" + p.split("/").filter(Boolean).slice(0, 6).map((s) => (/^[a-z][a-z-]{0,39}$/.test(s) ? s : ":x")).join("/");
}

const asalSitus = () => { try { return window.location.origin; } catch { return ""; } };
const diLuarSitus = (url) => { try { return new URL(url, asalSitus()).origin !== asalSitus(); } catch { return true; } };

// "at f (https://situs/static/js/main.1a.js:2:345)" (Chrome) atau "f@https://situs/static/js/main.1a.js:2:345" (Safari, Firefox)
const BINGKAI = /((?:https?|[a-z-]+-extension):\/\/[^\s()@]+?)(?:\?[^\s():]*)?:(\d+):(\d+)\)?\s*$/i;
export function bacaTumpukan(stack) {
  const bingkai = [];
  let ekstensi = false;
  for (const baris of String(stack || "").split("\n")) {
    if (SKEMA_EKSTENSI.test(baris)) ekstensi = true;
    const m = BINGKAI.exec(baris);
    if (!m) continue;
    const luar = diLuarSitus(m[1]);
    const nama = m[1].split("/").pop();
    bingkai.push({ luar, teks: `${nama}:${m[2]}:${m[3]}` });
  }
  return { bingkai, ekstensi };
}

const adalahObjek = (x) => x !== null && typeof x === "object";

/** "abaikan" | "jaringan" | "catat" */
export function jenisLaporan(galat, { berkas } = {}) {
  const pesan = String(adalahObjek(galat) ? galat.message : galat ?? "").trim();
  const nama = adalahObjek(galat) ? String(galat.name || "") : "";
  if (ABAIKAN.test(pesan) || nama === "AbortError") return "abaikan";
  if (berkas && (SKEMA_EKSTENSI.test(berkas) || diLuarSitus(berkas))) return "abaikan";
  if (adalahObjek(galat) && galat.isAxiosError) {
    if (galat.response) return "abaikan";          // jawaban server: 4xx bukan galat, 5xx sudah tercatat di server
    if (galat.code === "ERR_CANCELED") return "abaikan";
    return "jaringan";
  }
  const { bingkai, ekstensi } = bacaTumpukan(adalahObjek(galat) ? galat.stack : "");
  if (ekstensi || (bingkai[0] && bingkai[0].luar)) return "abaikan";
  if (JARINGAN.test(pesan)) return "jaringan";
  if (MUAT_BERKAS.test(pesan) || nama === "ChunkLoadError") {
    try { if (window.navigator.onLine === false) return "jaringan"; } catch { /* lanjut */ }
  }
  return "catat";
}

function sudahMasuk() {
  try { return !!window.localStorage.getItem("hs_token"); } catch { return false; }
}

function kirim(isi) {
  return fetch(ALAMAT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(isi), keepalive: true, credentials: "omit" });
}

const halamanKini = () => { try { return polaHalaman(window.location.pathname); } catch { return "/"; } };

const terkirim = new Set();
let jumlahLaporan = 0;
let hitunganJaringan = 0;
let timerHitungan = null;

function kirimHitungan() {
  timerHitungan = null;
  const n = hitunganJaringan;
  if (!n) return;
  hitunganJaringan = 0;
  try {
    kirim({ derau: "jaringan", jumlah: n, halaman: halamanKini(), commit: COMMIT, masuk: sudahMasuk() }).catch(() => { hitunganJaringan += n; });
  } catch { hitunganJaringan += n; }
}

function catatJaringan() {
  hitunganJaringan += 1;
  let daring = true;
  try { daring = window.navigator.onLine !== false; } catch { /* anggap daring */ }
  if (daring && !timerHitungan) timerHitungan = setTimeout(kirimHitungan, JEDA_HITUNGAN_MS);
}

/** Satu pintu laporan galat. Tidak pernah melempar. */
export function laporGalat(galat, { berkas, jenis } = {}) {
  try {
    const macam = jenisLaporan(galat, { berkas });
    if (macam === "abaikan") return false;
    if (macam === "jaringan") { catatJaringan(); return false; }
    const objek = adalahObjek(galat);
    // Objek selain Error tidak diuraikan: bisa berisi data pembeli
    const pesan = String(objek ? (galat.message || "Galat tanpa pesan") : galat ?? "Galat tanpa pesan").slice(0, MAKS_PESAN);
    const { bingkai } = bacaTumpukan(objek ? galat.stack : "");
    const tumpukan = bingkai.filter((b) => !b.luar).slice(0, MAKS_TUMPUKAN).map((b) => b.teks);
    const namaJenis = jenis || (objek && galat.name) || "Error";
    const halaman = halamanKini();
    const sidik = `${namaJenis}|${halaman}|${tumpukan[0] || pesan}`;
    if (terkirim.has(sidik) || jumlahLaporan >= MAKS_LAPORAN_PER_MUAT) return false;
    terkirim.add(sidik);
    jumlahLaporan += 1;
    kirim({ pesan, jenis: String(namaJenis).slice(0, 41), tumpukan, halaman, commit: COMMIT, masuk: sudahMasuk() }).catch(() => {});
    return true;
  } catch { return false; }
}

let terpasang = false;
/** Dipanggil sekali saat aplikasi dimuat (index.js), tanpa skrip inline. */
export function pasangPelaporGalat(win = window) {
  if (terpasang) return;
  terpasang = true;
  win.addEventListener("error", (e) => {
    const g = e.error || e.message;
    laporGalat(g, { berkas: e.filename });
  });
  win.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    laporGalat(r === undefined || r === null ? "Penolakan tanpa alasan" : r, { jenis: adalahObjek(r) && r.name ? undefined : "UnhandledRejection" });
  });
  win.addEventListener("online", () => { if (hitunganJaringan) kirimHitungan(); });
}

/** Hanya tes */
export function _aturUlang() {
  terkirim.clear(); jumlahLaporan = 0; hitunganJaringan = 0; terpasang = false;
  if (timerHitungan) clearTimeout(timerHitungan);
  timerHitungan = null;
}
